var map = {
	"./de": [
		"wBVm",
		6
	],
	"./de.json": [
		"wBVm",
		6
	],
	"./en-GB": [
		"XG68",
		5
	],
	"./en-GB.json": [
		"XG68",
		5
	],
	"./en-US": [
		"0TFE"
	],
	"./en-US.json": [
		"0TFE"
	],
	"./es": [
		"IM7x",
		4
	],
	"./es.json": [
		"IM7x",
		4
	],
	"./ro": [
		"cQwO",
		3
	],
	"./ro.json": [
		"cQwO",
		3
	],
	"./zh-HK": [
		"lpNb",
		2
	],
	"./zh-HK.json": [
		"lpNb",
		2
	],
	"./zh-SG": [
		"pKha",
		1
	],
	"./zh-SG.json": [
		"pKha",
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "nds2";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/lang/locales lazy ^\.\/.*$
// module id = nds2
// module chunks = 12